import React from 'react';

import BackSettingsScreen from './BackSettingsScreen';

export default (props: any) => (
  <BackSettingsScreen {...props} what="back_design" />
);
